<template>
  <div class="page" id="airport">
    <div class="loader" v-if="isLoading">
      <van-loading size="6.4vw">加载中...</van-loading>
    </div>
    <van-empty
      :description="errorMsg || '暂无数据'"
      v-else-if="!items || JSON.stringify(items) === '{}'"
    >
      <template #image>
        <img src="../assets/empty-image-error.png" />
      </template>
    </van-empty>
    <div v-else>
      <div class="banner-box">
        <van-image
          :src="image"
          class="banner"
          v-show="image"
          v-if="showBanner"
        ></van-image>
      </div>
      <div class="route-box">
        <div class="title">当前机场：{{ ds.AirportName }}</div>
        <div @click="$router.back(-1)" class="value">
          <span>切换机场</span>
          <van-icon name="arrow" />
        </div>
      </div>
      <div class="guide-box" v-if="showGuide">
        <router-link :to="'/airport/' + airportId + '/guide'">
          <span>服务机场路线指引</span>
          <van-icon class="arrow" name="arrow" />
        </router-link>
      </div>
      <Content-Box :arr="contentArr" />
      <div class="items">
        <div
          :key="'item@' + index"
          class="item-box"
          v-for="(item, index) in items"
        >
          <Terminal-Box :terminal="item" class="terminals" />
          <!-- 没有Remark或detail的时候不显示 -->
          <!-- <Terminal-Box :terminal="item" class="terminals" v-if="item.detail || (item.Remark && item.Remark != '')" /> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContentBox from "@/components/ContentBox.vue";
import TerminalBox from "@/components/TerminalBox.vue";
import Vue from "vue";
import { Empty, Icon, Image, Loading } from "vant";
Vue.use(Empty).use(Icon).use(Image).use(Loading);
export default {
  name: "Airport",
  components: { ContentBox, TerminalBox },
  data() {
    return {
      title: "银联机场贵宾权益",
      errorMsg: "",
      ds: null,
      isLoading: true,
      airportId: this.$route.params.id,
    };
  },
  computed: {
    items: function () {
      return (this.ds && this.ds.data) || null;
    },
    showBanner: function () {
      let { ds } = this;
      return (ds && ds.ImgServer && ds.PicAddress) || null;
    },
    image: function () {
      let { ds } = this;
      return (ds && ds.ImgServer + ds.PicAddress) || null;
    },
    showGuide: function () {
      let { items } = this;
      if (!items) return false;
      let flag = false;
      for (let i = 0; i < items.length; i++) {
        let displayGuide =
          parseInt(items[i].Display) &&
          items[i].LeadPic != "" &&
          items[i].LeadDetailPic != "";
        flag = displayGuide || flag;
      }
      return flag;
    },
    contentArr: function () {
      return [
        {
          content: (this.ds && this.ds.Remark) || null,
          color: (this.ds && this.ds.Color) || null,
        },
        {
          content: (this.ds && this.ds.Remark1) || null,
          color: (this.ds && this.ds.Color1) || null,
        },
      ];
    },
  },
  created() {
    this.$parent.setNav({
      title: this.title,
    });
  },
  mounted() {
    let that = this;

    let airportId = that.$route.params.id;

    // if (that.$globalStorage.items[airportId]) {
    //   that.isLoading = false;
    //   that.ds = that.$globalStorage.items[airportId];
    //   return false;
    // }

    that.$axios
      .post("/airport/" + airportId, {
        bankType: that.$locSearch.bankType,
      })
      .then((res) => {
        console.log(res);
        if (res.data.result != 0 || !res.data.data) {
          throw res;
        } else {
          that.ds = that.$globalStorage.items[airportId] = res.data;
        }
      })
      .catch((error) => {
        let errData = error.data;
        let desp = (errData && errData.description) || "获取失败";
        that.errorMsg = desp;
        // that.$dialog({ title: desp });
      })
      .then(() => {
        that.isLoading = false;
      });
  },
  methods: {},
};
</script>

<style lang="less">
@import "../main";
#airport.page {
  background: #f3f3f3;
  .loader {
    width: 100%;
    #bundle.flex-row();
    justify-content: center;
    align-items: center;
    min-height: inherit;
    box-sizing: border-box;
    padding-bottom: 5vh;
  }
  .banner-box {
    box-sizing: border-box;
    width: 100%;
    font-size: 0;
    padding: 8px 10px 0;
    .banner {
      width: 100%;
      height: 80px;
    }
  }
  .route-box {
    box-sizing: border-box;
    width: 355px;
    border: 1px solid #aaa;
    height: 33px;
    line-height: 33px;
    font-size: 14px;
    padding: 0 5px 0 10px;
    margin: 4px 10px;
    #bundle.flex-row();
    justify-content: space-between;
    align-items: center;
    .title {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
    .value {
      flex: none;
      padding-left: 20px;
    }
  }
  .guide-box {
    box-sizing: border-box;
    width: 355px;
    height: 33px;
    line-height: 33px;
    font-size: 14px;
    margin: 4px 10px;
    #bundle.flex-row();
    justify-content: flex-end;
    align-items: center;
    a {
      color: #bc0e27;
    }
    .arrow {
      position: relative;
      top: 1px;
      font-size: 16px;
    }
  }
  .items {
    padding: 15px 0;
    .terminals {
      padding-bottom: 10px;
    }
  }
}
</style>
